module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/universes/childcare-c2999840367d95cf1e0359b2d132c7b5.png";